import Auth from '@js/plugins/auth';
import Feature from '@js/plugins/feature';

export default {
    computed: {
        canManagePromotions() {
            return (
                Feature.hasFeature('promotion') &&
                Auth.hasPermissionTo('franchise_manage_marketing')
            );
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/promotion/mixin/promotion-permissions.js